export const IGetCookieSettingsUseCaseType = Symbol('IGetCookieSettingsUseCase');
